import { render, staticRenderFns } from "./RegionalRiskAssessment.vue?vue&type=template&id=36f4ee4c"
import script from "./RegionalRiskAssessment.vue?vue&type=script&lang=js"
export * from "./RegionalRiskAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports